<template>
    <div class="dropdown">
        <button
            class="dropdown-toggle"
            :class="[variantClass, toggleClass, getTypeButton, {
                'dropdown-toggle-no-caret': noCaret,
            }]"
            type="button"
            data-bs-toggle="dropdown"
            data-bs-boundary="viewport"
            :data-bs-auto-close="autoClose"
            :data-bs-popper-config="popperConfig"
            aria-expanded="false"
        >
            <slot name="button-content"></slot>
        </button>
        <ul class="dropdown-menu">
            <slot> </slot>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'BDropdown',
    props: {
        variant: { type: String, default: 'primary' },
        toggleClass: { type: String, default: null },
        noCaret: { type: Boolean, default: false },
        customSelect: { type: Boolean, default: false },
        autoClose: { type: [Boolean, String], default: true },
        fixedStrategy: { type: Boolean, default: true },
    },
    computed: {
        getTypeButton() {
            return this.customSelect ? 'form-select' : 'btn';
        },
        popperConfig() {
            if (!this.fixedStrategy) {
                return undefined;
            }
            return JSON.stringify({
                strategy: 'fixed',
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                        },
                    },
                ],
            });
        },
    },
    data() {
        return {
            variantClass: `btn-${this.variant}`,
        };
    },
};
</script>
